import { param } from 'jquery';
import { ROUTE_ARRAY } from './moengageEvents';

export const moengageTrackEvent = async (event, params = {}) => {
  const login_data = JSON.parse(localStorage.getItem('login_data'));
  if (login_data?.name) {
    window.Moengage.add_first_name(login_data?.name);
  }
  if (login_data?.email) {
    window.Moengage.add_email(login_data?.email);
  }
  if (login_data?.username) {
    window.Moengage.add_mobile(login_data?.username);
  }
  await window.Moengage.track_event(event, params);
};

export const APIErrorTrackEvent = (params) => {
  moengageTrackEvent('API_ERROR', params);
};

export const checkMoengageID = (node) => {
  if (!node) {
    return { idExists: false, data: '' };
  } else if (node.tagName === 'BODY') {
    return { idExists: false, data: '' };
  } else if (node && node.getAttribute && node.getAttribute('moenagage-id')) {
    return { idExists: true, data: node.getAttribute('moenagage-id') };
  } else if (node.parentNode) {
    return checkMoengageID(node.parentNode);
  } else {
    return { idExists: false, data: '' };
  }
};

export const getRouteParams = (path) => {
  const routeDetails = ROUTE_ARRAY.filter((item) => {
    if (path === item.routePath) {
      return item;
    }
  });

  return routeDetails[0];
};
